import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--hide-for", {
  from: units.px(0),
  to: units.px(100000)
});

// We need to be able to show/hide the container / its children based on dynamic
// media queries.
// As media queries does not support css-variables we instead 'hack' this using
// variables as logic gates as follows:
//
//  1) If the current viewport is greater than the from-value we set
//  --not-matches-from to 1px, otherwise it will be 0px.
//
//  2) now, we flip --not-matches-from such that --matches-from will be 1px if
//  the viewport is smaller than the bottom of the breakpoint.
//
//  3) If the current viewport is greater than the to-value we set
//  --matches-to to 1px, otherwise it will be 0px.
//
//  4) now, we finally ensure that at least one of these values is 1px before
//  showing our content (by setting max-width and max-height to very large
//  values)
const ssrContainer = "_ecs8sb78x";

export { ssrContainer, tokens };
import "./hide-for.style.linaria.module.css";
//# sourceMappingURL=hide-for.style.js.map
